import config from '../config';
import { getCurrentUserLocation, getUserCurrentLocationSP } from './localStorage';

const { defaultCountry, maps } = config;
const { supportedCountries: SC, supportedCountriesMapper } = maps;

export const countryMapper = {
    Schweiz: 'CH',
    Deutschland: 'DE',
    CH: 'Schweiz',
    DE: 'Deutschland',
};

export const exctractPublicDataCountry = currentUser => {
    const {
        attributes: {
            profile: { publicData },
        },
    } = currentUser || { attributes: { profile: { publicData: {} } } };
    const { country: publicDataCountry = null } = publicData || {};

    return publicDataCountry;
};

export const mapUserCountryByCountryCode = (countryCode = 'CH') => {
    return supportedCountriesMapper[countryCode];
};

export const getUserCountry = () => {
    const { country: ipAddressCountry, countrySelected } = getCurrentUserLocation();
    const countryMapped = mapUserCountryByCountryCode(countrySelected || ipAddressCountry);

    return (
        countryMapped ||
        (countrySelected && SC[countrySelected] ? countrySelected : null) ||
        (ipAddressCountry && SC[ipAddressCountry] ? ipAddressCountry : null) ||
        defaultCountry
    );
};

export const getUserCountryName = () => SC[getUserCountry()].name;

export const getUserAddress = () => {
    const { defaultAddress } = SC[getUserCountry()];
    const { bounds, origin, address } = defaultAddress;
    return { bounds, origin, address };
};

export const isSupportedCountry = (country, config) =>
    country && (config || SC)[country] ? country : defaultCountry;

export const getUserCountrySpecInfo = (country, config = null) =>
    (config || SC)[isSupportedCountry(country, config)];

/**
 * Resolves location string from user public data values
 * the order of units has to be the same as google api address from response
 * @returns string
 */
export const getUserLocationUnitStr = ({
    intl,
    country = '',
    postalCode = '',
    city = '',
    streetAddress = '',
    houseNumber = '',
}) => {
    const addressLine = [streetAddress, houseNumber].filter(Boolean).join(' ');
    const cityLine = [postalCode, city].filter(Boolean).join(' ');
    const countryName =
        country && intl
            ? intl.formatMessage({
                  id: `PayoutDetailsForm.countryNames.${country}`,
              })
            : '';

    if (!addressLine || !cityLine) return '';

    return [addressLine, cityLine, countryName].filter(Boolean).join(', ');
};
/**
 * Check if search params match with current user local storage search params
 * @param {object} searchParams - origin, address
 * @returns
 */
export const userLocationSearchParamsMatch = searchParams => {
    const currentLocationLS = getUserCurrentLocationSP() || {};
    const { address, origin } = searchParams;
    const { address: lsAddress, origin: lsOrigin } = currentLocationLS;

    const addressMatch = address === lsAddress;
    const originMatch =
        origin && lsOrigin && origin.lat === lsOrigin.lat && origin.lng === lsOrigin.lng;

    return addressMatch && originMatch;
};

export const getCurrentUserLocationUnitsStr = currentUser => {
    if (!currentUser?.id?.uuid) return null;

    const { city, postalCode } = currentUser.attributes.profile.publicData;

    return `${postalCode} ${city}, ${getUserCountryName()}`;
};

export const getHorseListingLocationUnitsStr = horseListing => {
    if (!horseListing?.id?.uuid) return null;

    const { country, location, postalCode } =
        horseListing.attributes.publicData?.addressDetails || {};

    return `${postalCode} ${location}, ${countryMapper[country] || ''}`;
};

export const getCenterFromBounds = bounds => {
    if (!bounds || typeof bounds !== 'string') return null;

    const parts = bounds.split(',').map(Number);

    if (parts.length !== 4 || parts.some(n => !Number.isFinite(n))) {
        return null;
    }

    const [north, east, south, west] = parts;

    const lat = (north + south) / 2;
    const lng = (east + west) / 2;

    return `${lat},${lng}`;
};
